function parseAttachmentMessage(value) {
  const raw = String(value || '').trim();
  const urlMatch = raw.match(/(https?:\/\/[^\s]+)/);
  if (!urlMatch) return null;

  const url = urlMatch[1];
  const firstLine = raw.split(/\r?\n/)[0].trim();
  const definitions = [
    { kind: 'image', label: '图片', pattern: /^(?:【图片】|\[Image\])\s*/i, preview: true },
    { kind: 'screenshot', label: '截图', pattern: /^(?:【截图】|\[Screenshot\])\s*/i, preview: true },
    { kind: 'file', label: '文件', pattern: /^(?:【文件】|\[File\])\s*/i, preview: false },
  ];
  const definition = definitions.find(item => item.pattern.test(firstLine));
  if (!definition) return null;

  const name = firstLine.replace(definition.pattern, '').trim() || definition.label;
  return {
    kind: definition.kind,
    label: definition.label,
    name,
    url,
    preview: definition.preview,
  };
}

function formatReverseGeocodeAddress(data) {
  const address = data?.address || {};
  const road = [
    address.road || address.pedestrian || address.footway || address.residential || address.path,
    address.house_number,
  ].filter(Boolean).join(' ');
  const area = address.neighbourhood || address.suburb || address.village || address.town || address.city_district;
  const city = address.city || address.county || address.state;
  const compact = [road || data?.name, area, city]
    .filter(Boolean)
    .filter((item, index, list) => list.indexOf(item) === index)
    .slice(0, 3)
    .join(' · ');

  if (compact) return compact;
  return String(data?.display_name || '').split(',').slice(0, 3).map(part => part.trim()).filter(Boolean).join(' · ');
}

async function reverseGeocodeLocation(latitude, longitude, language) {
  try {
    const params = new URLSearchParams({
      format: 'jsonv2',
      lat: String(latitude),
      lon: String(longitude),
      addressdetails: '1',
      zoom: '18',
      'accept-language': language === 'zh' ? 'zh-CN,zh,en' : 'en',
    });
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?${params.toString()}`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return '';
    return formatReverseGeocodeAddress(await response.json());
  } catch {
    return '';
  }
}

function parseLocationMessage(value) {
  const raw = String(value || '').trim();
  const urlMatch = raw.match(/(https?:\/\/[^\s]+)/);
  if (!urlMatch) return null;

  const url = urlMatch[1];
  const isLocationPrefix = /^(?:【位置】|\[Location\])/i.test(raw);
  const isMapUrl = /\/\/maps\.google\./i.test(url) || /\/maps/i.test(url);
  if (!isLocationPrefix && !isMapUrl) return null;
  const address = isLocationPrefix
    ? raw.replace(/^(?:【位置】|\[Location\])\s*/i, '').replace(url, '').trim()
    : '';

  let lat = null;
  let lng = null;

  try {
    const parsed = new URL(url);
    const query = parsed.searchParams.get('q') || parsed.searchParams.get('query') || '';
    const coordMatch = query.match(/(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)/)
      || url.match(/@(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)/);
    if (coordMatch) {
      const nextLat = Number(coordMatch[1]);
      const nextLng = Number(coordMatch[2]);
      if (
        Number.isFinite(nextLat)
        && Number.isFinite(nextLng)
        && Math.abs(nextLat) <= 90
        && Math.abs(nextLng) <= 180
      ) {
        lat = nextLat;
        lng = nextLng;
      }
    }
  } catch {
    // Fall back to an openable map card even when the URL cannot be parsed.
  }

  return { url, address, lat, lng };
}

export {
  formatReverseGeocodeAddress,
  parseAttachmentMessage,
  parseLocationMessage,
  reverseGeocodeLocation,
};
